import { render, staticRenderFns } from "./PreferenceItem.vue?vue&type=template&id=0483aeac&scoped=true"
import script from "./PreferenceItem.vue?vue&type=script&lang=js"
export * from "./PreferenceItem.vue?vue&type=script&lang=js"
import style0 from "./PreferenceItem.vue?vue&type=style&index=0&id=0483aeac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0483aeac",
  null
  
)

export default component.exports